//import React from "react";
//import "./DegisimIadeProseduru.css";
//import bgSvg from "../assets/bg.svg";
//import Navbar from "../components/Navbar";

//function DegisimIadeProseduru() {
//    return (
//        <div className="degisim-page" style={{ backgroundImage: `url(${bgSvg})` }}>
//            <Navbar />
//            <div className="degisim-card">
//                <div className="degisim-content">
//                    <h1 className="degisim-title">
//                        SPORTIVE DEĞİŞİM VE İADE KOŞULLARI
//                    </h1>

//                    <h1 className="degisim-title">
//                        <span>SPORTIVE RETURN & EXCHANGE POLICY</span>
//                    </h1>

//                    <ul>
//                        <li>
//                            Mağazalarımızdan satın almış olduğunuz ürünleri, fiş veya slip ibrazı
//                            ile 14 gün içerisinde iade edebilir, 30 gün içerisinde ise değiştirebilirsiniz.
//                            <br />
//                            <span className="green">
//                                Products can be returned within 14 days or exchanged within 30 days, provided that the receipt or sales slip is presented.
//                            </span>
//                        </li>
//                        <br />
//                        <li>
//                            Ürünler kullanılmamış, yıkanmamış, giyilmemiş, tadilat görmemiş ve hasar almamış olmalı, orijinal niteliğini kaybetmemiş olmalıdır. İade edilmek istenen ürün, satın alındığı andaki gibi kusursuz, eksiksiz ve orijinal kutusunda olmalıdır. Kutusu, ambalajı ve varsa standart aksesuarlarıyla birlikte eksiksiz ve hasarsız olarak teslim edilmeyen ürünlerin iadesi mümkün değildir.
//                            <br />
//                            <span className="green">
//                                The products must be unused, unwashed, unworn, unaltered, and undamaged, and  must retain their original condition. The product to be returned must be flawless, complete, and in its original box, just it was when purchased. Products that are not returned with their box, packaging, and standard accessories,
//                                if any, in complete and undamaged condition, cannot be refunded.
//                            </span>
//                        </li>
//                        <br />
//                        <li>
//                            Kullanılmış tüm ürünler, iade süresi içinde olsa dahi, satılabilirlik özelliklerini yitirdikleri için iade alınmaz.
//                            <br />
//                            <span className="green">
//                             None of the used products cannot be returned, even if they are within the return period, due to loss of resale condition/value.
//                            </span>
//                        </li>
//                        <br />
//                        <li>
//                            Aksesuar, iç giyim ve mayo/bikini gibi hijyen ürünlerinde iade veya değişim yapılmaz.
//                            <br />
//                            <span className="green">
//                             Accessories, underwear, and swimwear (bikini/swimsuit) cannot be returned or exchanged due to hygiene reasons.
//                            </span>
//                        </li>
//                        <br />
//                        <li>
//                            Özel sipariş ve kişiselleştirilmiş ürünlerin iade ve değişimi mümkün değildir.
//                            <br />
//                            <span className="green">
//                                Special order and personalized products cannot be returned or exchanged.
//                            </span>
//                        </li>
//                        <br />
//                        <li>
//                            Hediye kartı ya da hediye fişiyle yapılan alışverişlerde yalnızca değişim yapılabilir; para iadesi yapılamaz.
//                            <br />
//                            <span className="green">
//                             Purchases made with gift cards or gift receipts are eligible for exchange only; refunds are not available.
//                            </span>
//                        </li>
//                        <br />
//                        <li>
//                            Franchise mağazalarımızdan satın alınan ürünlerin iade ve değişimi, yalnızca ürünün satın alındığı franchise mağazasında yapılabilir.
//                            <br />
//                            <span className="green">
//                                Returns and exchanges for items purchased from our franchise stores must be processed at the same franchise store where the purchase was made.
//                            </span>
//                        </li>
//                        <br />
//                        <li>
//                            Franchise Mağazalarımız <span>/ Our Franchise Stores:</span>
//                            <br />
//                            <span className="green">
//                             Amasya, Alanya Akdeniz Park AVM, Alanyum AVM, Konya
//                            </span>
//                        </li>

//                    </ul>


//                </div>
//            </div>
//        </div>
//    );
//}

//export default DegisimIadeProseduru;

import React from "react";
import "./DegisimIadeProseduru.css";
import bgSvg from "../assets/bg.svg";
import Navbar from "../components/Navbar";

function DegisimIadeProseduru() {
    return (
        <div
            className="degisim-page"
            style={{
                backgroundImage: `url(${bgSvg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                minHeight: "100vh"
            }}
        >
            <Navbar />

            <div className="degisim-wrapper">
                <div className="degisim-card">

                    <h1 className="degisim-title">SPORTIVE DEĞİŞİM VE İADE KOŞULLARI</h1>
                    <h2 className="degisim-subtitle">SPORTIVE RETURN & EXCHANGE POLICY</h2>

                    <ul className="degisim-list">
                        <li>
                            Mağazalarımızdan satın almış olduğunuz ürünleri, fiş veya slip ibrazı
                           ile 14 gün içerisinde iade edebilir, 30 gün içerisinde ise değiştirebilirsiniz.
                            <em>
                                Products can be returned within 14 days or exchanged within 30 days, provided that the receipt or sales slip is presented.
                            </em>
                        </li>
                        <br>
                        </br>
                        <li>
                            Ürünler kullanılmamış, yıkanmamış, giyilmemiş, tadilat görmemiş ve hasar almamış olmalı, orijinal niteliğini kaybetmemiş olmalıdır. İade edilmek istenen ürün, satın alındığı andaki gibi kusursuz, eksiksiz ve orijinal kutusunda olmalıdır. Kutusu, ambalajı ve varsa standart aksesuarlarıyla birlikte eksiksiz ve hasarsız olarak teslim edilmeyen ürünlerin iadesi mümkün değildir.                            
                            <em>
                                The products must be unused, unwashed, unworn, unaltered, and undamaged, and  must retain their original condition. The product to be returned must be flawless, complete, and in its original box, just it was when purchased. Products that are not returned with their box, packaging, and standard accessories,
                                if any, in complete and undamaged condition, cannot be refunded.
                            </em>
                        </li>
                        <br>
                        </br>
                        <li>
                            Kullanılmış tüm ürünler, iade süresi içinde olsa dahi, satılabilirlik özelliklerini yitirdikleri için iade alınmaz.
                            <em>
                                None of the used products cannot be returned, even if they are within the return period, due to loss of resale condition/value.
                            </em>
                        </li>
                        <br>
                        </br>
                        <li>
                            Aksesuar, iç giyim ve mayo/bikini gibi hijyen ürünlerinde iade veya değişim yapılmaz.
                            <em>
                                Accessories, underwear, and swimwear (bikini/swimsuit) cannot be returned or exchanged due to hygiene reasons.
                            </em>
                        </li>
                        <br>
                        </br>
                        <li>
                            Özel sipariş ve kişiselleştirilmiş ürünlerin iade ve değişimi mümkün değildir.
                            <em>
                                Special order and personalized products cannot be returned or exchanged.
                            </em>
                        </li>
                        <br>
                        </br>
                        <li>
                            Hediye kartı ya da hediye fişiyle yapılan alışverişlerde yalnızca değişim yapılabilir; para iadesi yapılamaz.
                            <em>
                                Purchases made with gift cards or gift receipts are eligible for exchange only; refunds are not available.
                            </em>
                        </li>
                        <br>
                        </br>
                        <li>
                            Franchise mağazalarımızdan satın alınan ürünlerin iade ve değişimi, yalnızca ürünün satın alındığı franchise mağazasında yapılabilir.
                            <em>
                                Returns and exchanges for items purchased from our franchise stores must be processed at the same franchise store where the purchase was made.
                            </em>
                        </li>
                        <br>
                        </br>
                        <li>
                            Franchise Mağazalarımız / Our Franchise Stores:
                            <em>
                                   Amasya, Alanya Akdeniz Park AVM, Alanyum AVM, Konya
                            </em>
                        </li>
                    </ul>

                </div>
            </div>
        </div>
    );
}

export default DegisimIadeProseduru;
